import React from 'react';
import GlyphDropdown from './GlyphDropdown'
import MergeDropZone from './MergeDropZone'

const CodeLabelRight = ({
  showMerge,
  showConfirmMerge,
  confirmMerge,
  cancelMerge,
  onRename,
  onSeeDetails,
  deleteCode,
  showDropdown,
  codeId,
  codeName,
  codeNesterAnchorRef,
  maxDepth,
  dropRef // Passed down from CodeLabel/useMergeInteraction
}) => {
  // Show merge zone if hovering OR confirming
  const shouldShowMerge = showMerge || showConfirmMerge;

  return dropRef(
    <div>
      {shouldShowMerge ? (
        <MergeDropZone
          codeID={codeId}
          showMerge={shouldShowMerge}
          showConfirmMerge={showConfirmMerge}
          confirmMerge={confirmMerge}
          onHide={cancelMerge}
        />
      ) : (
        <GlyphDropdown 
          show={showDropdown}
          seeDetails={onSeeDetails}
          onRename={onRename}
          deleteCode={deleteCode}
          codeId={codeId}
          codeName={codeName}
          codeNesterAnchorRef={codeNesterAnchorRef}
          maxDepth={maxDepth}
        />
      )}
    </div>
  );
};

export default CodeLabelRight;